export default function() {
	const { order, injured, setting } = this
	let arr = []

	if (this.isLivingInvestigate) {
		const livingInfo = {
			title: '居住信息',
			children: [
				{ type: '2000', picName: '居住地大门照' },
				{ type: '2001', picName: '门牌号' },
			],
		}

		const landlordInfo = {
			title: '房东物业信息',
			children: [{ type: '2002', picName: '房东/物业人员证明照' }],
		}

		const committeeInfo = {
			title: '居委会/村委会/街道办信息',
			children: [{ type: '2003', picName: '居委会/村委会/街道办大门照' }],
		}

		const surveyInfo = {
			title: '调查信息',
			children: [
				{ type: '2004', picName: '购房合同/租房合同' },
				{ type: '2005', picName: '居住证/暂住证' },
				{ type: '2006', picName: '水电费缴费单' },
				{ type: '2007', picName: '其他证明材料' },
			],
		}

		arr.push(livingInfo, landlordInfo, committeeInfo)
		if (
			injured.homeLandLordSurvey &&
			injured.homeLandLordSurvey.facticity !== '0'
		) {
			arr.push(surveyInfo)
		}
	}
	if (this.isWorkInvestigate) {
		const companyInfo = {
			title: '公司信息',
			children: [
				{ type: '2008', picName: '公司大门照' },
				{ type: '2009', picName: '公司前台照' },
			],
		}

		const intervieweeInfo = {
			title: '被询问人信息',
			children: [{ type: '2010', picName: '被询问人证明材料' }],
			desc: '（被询问人的工牌、邮箱、名片等）',
		}

		const workProveInfo = {
			title: '工作证明信息',
			children: [{ type: '2015', picName: '劳动合同/劳务派遣合同' }],
		}

		const jobProveInfo = {
			title: '岗位证明信息',
			children: [
				{ type: '2011', picName: '工位照片' },
				{ type: '2012', picName: '工牌照片' },
				{ type: '2013', picName: '公司通讯录照片' },
				{ type: '2014', picName: '公司邮箱照片' },
			],
		}
		arr.push(companyInfo, intervieweeInfo)
		if (
			injured.workCompanySurvey &&
			injured.workCompanySurvey.injuredAtComppany !== '0'
		) {
			arr.push(workProveInfo, jobProveInfo)
		}
	}

	arr.push({
		title: '电子签名',
		slot: 'sign',
	})

	const signIn = {
		title: '签到',
		children: [],
	}
	if (this.isLivingInvestigate) {
		signIn.children.push({ type: '0403', picName: '本人与居住地门牌合照' })
	} else if (this.isWorkInvestigate) {
		signIn.children.push({ type: '0404', picName: '本人与公司门牌合照' })
	}
	arr.push(signIn)

	arr.push(
		{
			title: '其他',
			desc: '（非必传）',
			children: [{ type: '0900', picName: '其他' }],
		},
		{
			title: '视频信息',
			desc: '（非必传）',
			slot: 'videoList',
		}
	)

	return arr
}
